module.exports = __webpack_public_path__ + "static/img/sec1-cont01-img02.f6997e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec1-cont01-img02.jpg
// module id = I2lo
// module chunks = 0